import axios from 'axios';

// Trazas solo en desarrollo (Ola 7, punto 7-08). Los interceptores anteriores
// escribian en consola en cada peticion y en cada respuesta, incluidas las
// rutas calientes.
const DEPURAR = import.meta.env.DEV && import.meta.env.VITE_DEPURAR_API === 'true';
const traza = (...argumentos) => { if (DEPURAR) console.debug(...argumentos); };

/**
 * Cliente HTTP unico de la aplicacion (Ola 5).
 *
 * Sustituye a los dos que convivian: uno con baseURL absoluta al host de
 * desarrollo y otro con ruta relativa. La
 * autenticacion viajaba por una ruta de red distinta al resto de la aplicacion,
 * de modo que desde cualquier otra maquina el login fallaba mientras el resto
 * de la interfaz funcionaba (hallazgo A-20).
 *
 * Ahora todo va por rutas relativas: el proxy de Vite en desarrollo y el nginx
 * del contenedor en produccion se encargan de enrutar hacia el backend. No hay
 * dominios ni puertos compilados en el bundle (hallazgo A-24).
 */

const CLAVE_TOKEN = 'gestas_access_token';
const CLAVE_REFRESCO = 'gestas_refresh_token';

export const almacenamientoTokens = {
  obtenerAcceso: () => localStorage.getItem(CLAVE_TOKEN),
  obtenerRefresco: () => localStorage.getItem(CLAVE_REFRESCO),
  guardarAcceso: (token) => localStorage.setItem(CLAVE_TOKEN, token),
  guardarRefresco: (token) => localStorage.setItem(CLAVE_REFRESCO, token),
  limpiar: () => {
    localStorage.removeItem(CLAVE_TOKEN);
    localStorage.removeItem(CLAVE_REFRESCO);
  },
};

const cliente = axios.create({
  // Ruta relativa a proposito: la aplicacion no sabe ni debe saber en que
  // dominio ni en que puerto se sirve.
  baseURL: '',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

cliente.interceptors.request.use(
  (configuracion) => {
    const token = almacenamientoTokens.obtenerAcceso();
    if (token) configuracion.headers.Authorization = `Bearer ${token}`;
    return configuracion;
  },
  (error) => Promise.reject(error)
);

/** Evita que varias peticiones fallidas a la vez disparen varios refrescos. */
let refrescoEnCurso = null;

const refrescarSesion = async () => {
  const refresco = almacenamientoTokens.obtenerRefresco();
  if (!refresco) throw new Error('No hay token de refresco.');

  const { data } = await axios.post('/api/auth/refresh', { refreshToken: refresco });
  const nuevoToken = data?.data?.accessToken;
  if (!nuevoToken) throw new Error('La respuesta de refresco no trae token.');

  almacenamientoTokens.guardarAcceso(nuevoToken);
  return nuevoToken;
};

cliente.interceptors.response.use(
  (respuesta) => respuesta,
  async (error) => {
    const original = error.config;

    if (error.response?.status !== 401 || original?._reintentado) {
      return Promise.reject(error);
    }

    original._reintentado = true;

    try {
      refrescoEnCurso = refrescoEnCurso || refrescarSesion();
      const nuevoToken = await refrescoEnCurso;
      refrescoEnCurso = null;

      original.headers.Authorization = `Bearer ${nuevoToken}`;
      return cliente(original);
    } catch (fallo) {
      refrescoEnCurso = null;
      almacenamientoTokens.limpiar();
      if (window.location.pathname !== '/login') window.location.href = '/login';
      return Promise.reject(fallo);
    }
  }
);

export default cliente;
